import React, { useEffect } from 'react';
import GetStarted from './components/Steps/GetStarted';
import { Route, Switch, useHistory } from 'react-router-dom';

import { Dispatch } from 'redux';
import { configs } from '../../constants/configs/configs';
import ContactInformation from './components/Steps/ContactInformation';
import IdentityQuestions from './components/Steps/IdentityQuestions';
import CallExperian from './components/Steps/CallExperian';
import ManualVerification from './components/Steps/ManualVerification';
import Layout from './components/Layout';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { environmentSelector } from '../../selectors/commonSelectors';
import { fetchCurrentUserInfoDetails, fetchCurrentUserViewRef } from '../../actions/ridp/ridpActionCreators';
import endpoints from '../../constants/configs/endpoints';
import Finish from './components/Steps/Finish';
import UploadDocumentProcess from './components/Steps/UploadDocumentProcess';
import { IUserInfo } from './types/ridpTypes';

const RIDP = () => {
    const {
        routes: {
            RIDP,
            RIDP_CONTACT_INFO,
            RIDP_IDENTITY_QUESTION,
            RIDP_CALL_EXPERIAN,
            RIDP_UPLOAD_DOCUMENT,
            RIDP_TECHNICAL_ERROR,
            RIDP_VERIFICATION_COMPLETE,
            RIDP_VERIFICATION_REJECTED,
            RIDP_UPLOAD_DOCUMENT_PROCESS,
        },
    } = configs;
    const history = useHistory();

    const environment = useAppSelector(environmentSelector);
    const viewRef = useAppSelector(state => state.ridp.viewRef);
    const currentUserInfo = useAppSelector(state => state.ridp.currentUserInfo) as IUserInfo;

    const dispatch: Dispatch<any> = useAppDispatch();
    const existingParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (!viewRef) {
            dispatch(fetchCurrentUserViewRef(endpoints.RIDP_VIEWREF_ENDPOINT, environment));
        } else {
            dispatch(
                fetchCurrentUserInfoDetails(
                    endpoints.RIDP_CURRENT_USER_INFO_ENDPOINT.processReplacements({
                        viewRef,
                        ts: Date.now(),
                    }),
                    environment,
                ),
            );
        }
    }, [viewRef]);

    useEffect(() => {
        if (currentUserInfo && currentUserInfo.ridpVerified === 'Y') {
            history.push(`${RIDP_VERIFICATION_COMPLETE}?${existingParams.toString()}`);
        } else if (currentUserInfo && currentUserInfo.ridpSource === 'MANUAL') {
            if (!Array.isArray(currentUserInfo.documentsUploaded) || currentUserInfo.documentsUploaded.length === 0) {
                history.push(`${RIDP_UPLOAD_DOCUMENT}?${existingParams.toString()}`);
            } else {
                const hasSubmitted = currentUserInfo.documentsUploaded.some(doc => doc.status === 'SUBMITTED');

                if (hasSubmitted) {
                history.push(`${RIDP_UPLOAD_DOCUMENT_PROCESS}?${existingParams.toString()}`);
                } else if (currentUserInfo.documentsUploaded.some(doc => doc.status === 'REJECTED')) {
                    history.push(`${RIDP_VERIFICATION_REJECTED}?${existingParams.toString()}`);
            } else {
                history.push(`${RIDP_UPLOAD_DOCUMENT}?${existingParams.toString()}`);
            }
            }
        } else if (currentUserInfo && currentUserInfo.ridpSource === 'FARS') {
            if (currentUserInfo.sixteenHourBlock) {
                history.push(`${RIDP_TECHNICAL_ERROR}?${existingParams.toString()}`);
            } else {
                history.push(`${RIDP_CALL_EXPERIAN}?${existingParams.toString()}`);
            }
        }
    }, [currentUserInfo]);

    return currentUserInfo ? (
        <Switch>
            <Route path={RIDP} exact>
                <Layout>
                    <GetStarted />
                </Layout>
            </Route>
            <Route path={RIDP_CONTACT_INFO} exact>
                <Layout>
                    <ContactInformation />
                </Layout>
            </Route>
            <Route path={RIDP_IDENTITY_QUESTION} exact>
                <Layout>
                    <IdentityQuestions />
                </Layout>
            </Route>
            <Route path={RIDP_CALL_EXPERIAN} exact>
                <Layout>
                    <CallExperian />
                </Layout>
            </Route>
            <Route path={RIDP_UPLOAD_DOCUMENT} exact>
                <Layout>
                    <ManualVerification />
                </Layout>
            </Route>
            <Route path={RIDP_VERIFICATION_REJECTED} exact>
              <Layout>
                <ManualVerification />
              </Layout>
            </Route>
            <Route path={RIDP_TECHNICAL_ERROR} exact>
                <Layout>
                    <Finish />
                </Layout>
            </Route>
            <Route path={RIDP_VERIFICATION_COMPLETE} exact>
                <Layout>
                    <Finish />
                </Layout>
            </Route>
            <Route path={RIDP_UPLOAD_DOCUMENT_PROCESS} exact>
                <Layout>
                    <UploadDocumentProcess />
                </Layout>
            </Route>
        </Switch>
    ) : null;
};

export default RIDP;
